define('modules/button/button_model',['backbone'], function (Backbone) {
  'use strict';
  var ButtonModel = Backbone.Model.extend({
    defaults: {
      icon: null,
      icon_location: 'before'
    }
  });

  return ButtonModel;
});
